export const enum StyledGateModalVariant {
  CHANGE_STYLE = 'CHANGE_STYLE',
  NEW_CITATION_LIST_MODAL = 'NEW_CITATION_LIST_MODAL',
}
